import { SelectInput, styled } from 'canoe';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useState } from 'react';

const Container = styled.div`
  width: 180px;
  > div {
    width: 100%;
  }
`;
const items = [
  'auto',
  'pointer',
  'default',
  'none',
  'context-menu',
  'help',
  'progress',
  'wait',
  'cell',
  'crosshair',
  'text',
  'vertical-text',
  'alias',
  'copy',
  'move',
  'no-drop',
  'not-allowed',
  'grab',
  'grabbing',
  'all-scroll',
  'zoom-in',
  'zoom-out',
].map((value) => ({ value, label: value }));

interface Props {
  value?: string;
  onChange: (cursor: string) => void;
  disabled?: boolean;
}

export const CursorPicker = ({ value = '', onChange, disabled }: Props) => {
  const [searchValue, setSearchValue] = useState('');
  const onClearSearch = useCallback(() => {
    setSearchValue('');
  }, []);
  const filteredItems = useMemo(() => {
    if (!searchValue) {
      return items;
    }

    return items.filter((item) => {
      return item.label.toLowerCase().includes(searchValue?.toLowerCase());
    });
  }, [searchValue, items]);

  const updateSearchValue = debounce((e) => {
    setSearchValue(e.target.value);
  }, 300);

  return (
    <Container>
      <SelectInput
        searchable
        clearable={false}
        onFilter={updateSearchValue}
        onOpeningChange={onClearSearch}
        onClearFilter={onClearSearch}
        searchInputProps={{
          placeholder: `Search a cursor`,
        }}
        disabled={disabled}
        selectedItem={items.find((item) => item.value === value)}
        items={filteredItems}
        onSelect={(selected) => {
          if (selected) {
            onChange(selected.value);
          }
        }}
      />
    </Container>
  );
};
